<template>
  <div>
    <template v-if="isMobile">
    <div id="containerMobile">
      <template v-if="!isLoggedButton">
        <router-link to="/login"
         ><button class="mb-1">Fazer Login</button></router-link
         >
      </template>
      <template v-else>
        <template v-if="!isFree">
          <router-link to="/acervo"
         ><button class="mb-1">Acervo</button></router-link
         >
        </template>
        
         <router-link to="/respostas"
         ><button class="mb-1">Respostas</button></router-link
         >
      </template>
        

              <img
                class="imageMobile"
                src="../assets/images/01-homeMobile2.png"
                alt="1 slide"
              />
              <img
                class="imageMobile"
                src="../assets/images/01-homeMobile1.png"
                alt="1 slide"
              />


    </div>
    </template>
    <template v-else>
    <div id="container">
      <!-- <header class="header">
          <Navbar />
        </header> -->
      <div style="!important;" >
        <div
          id="carouselExampleControls"
          class="carousel slide"
          data-ride="carousel"
        >
          <div class="carousel-inner">
            <div class="carousel-item active">
              <img
                @click="() => {}"
                class="w-100 h-100"
                src="../assets/images/01-home.png"
                alt="1 slide"
              />
              <!-- $router.push({path: '/banca/'}) -->
            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import decode from "jwt-decode";
import firebase from "firebase";
// import Navbar from "../components/Navbar";

export default {
  components: {
    // Navbar: Navbar,
  },
  name: "Home",
  data: () => ({
    user: {},
    isMobile: false,
    isLoggedButton: false,
    isFree:false,
  }),
  mounted: async function () {
    this.isLoggedButton = this.$store.getters.logado;
    //console.log("esta logado? ", this.$store.getters)
    let tipo = JSON.parse(localStorage.getItem("typeOfUser"));
        if (tipo == "1" || tipo === null || tipo === undefined || isNaN(tipo)) {
          this.isFree = true;
          console.log("é gratuito")
        } else {
          this.isFree = false;
          console.log("é poago")
        }
    this.getUserGoogle();

    if (localStorage.getItem("t")) {
      this.intercomSubmit();
      this.analyticSubmit();
    } else {
      this.$intercom.shutdown();
    }
    var win = window,
        doc = document,
        docElem = doc.documentElement,
        body = doc.getElementsByTagName("body")[0],
        x = win.innerWidth || docElem.clientWidth || body.clientWidth;
      if (x < 800) {
        this.isMobile= true;
      }
  },
  methods: {
    intercomSubmit: async function () {
      await this.$axios
        .get(`jogo/perfil_publico/${decode(localStorage.getItem("t")).usr.id}`)
        .then((res) => res.data)
        .then((res) => {
          this.user = res;
        })
        .catch((err) => {
          console.log("Falha ao buscar user", err);
        });
      this.$intercom.boot({
        email: this.user.email,
        name: this.user.name,
        user_id: this.user.id,
        phone: this.user.celular,
        hide_default_launcher: true,
      });
      this.$intercom.update({
        email: this.user.email,
        name: this.user.name,
        user_id: this.user.id,
        phone: this.user.celular,
      });
    },
    analyticSubmit: function () {
      try {
        this.$intercom.trackEvent("WEB_tela_home");
      } catch (error) {
        console.log("analyticIntercom home error:", error);
      }
    },
    getUserGoogle: async function () {
      await firebase
        .auth()
        .getRedirectResult()
        .then((result) => {
          if (result.credential) {
            // This gives you a Google Access Token. You can use it to access the Google API.
            var token = result.credential.accessToken;
            console.log("token do google");
            console.log(token);

            // ...
          }
          console.log("resultado do getRedirectResult");
          console.log(result);
        })
        .catch(function (error) {
          console.log("error do getRedirectResult");
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
#containerMobile {
  display: flex;
  flex-direction: column;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  padding: 10px 10px;
  height: 100vh;
  background-size: cover;
  background-color: rgb(235, 235, 235);
  overflow: auto;
}
.imageMobile{
  width: 100%;
}
button {
  border: none;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 2px 10px;
  font-size: 12px;
  height: 50px;
  width: 100px;
  font-weight: bold;
  background-color: #4e9c5f;
  color: white;
}
#container {
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  height: 100vh;
  background-size: cover;
  background-color: rgb(235, 235, 235);
}

.carousel .carousel-item {
  width: 100%;
}

.carousel-item img {
  background-size: cover !important;
  background-position: center;
  object-fit: cover;
  cursor: pointer;
}

.item img {
  position: absolute;
  top: 0;
  left: 0;
  min-height: 300px;
  background-position: center;
}
</style>
